import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done",
  "use": "done-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol viewBox=\"0 0 35 35\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done\"><circle cx=\"17.5\" cy=\"17.5\" r=\"17.5\" /><path d=\"M15 23L26 12\" stroke-width=\"2\" /><path d=\"M10 17L16 23\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol